import { render, staticRenderFns } from "./QrBadge.vue?vue&type=template&id=2237a42a&scoped=true&"
import script from "./QrBadge.vue?vue&type=script&lang=ts&"
export * from "./QrBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2237a42a",
  null
  
)

export default component.exports